import React, { Component } from 'react';

import { Media, Content } from '../../components';
import Visible from '../Visible';
import * as Breakpoints from '../Breakpoints';

class Feature extends Component {
  nl2br = (str) => {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    var breakTag = '<br>';
    return (str + '').replace(
      /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
      '$1' + breakTag + '$2'
    );
  };

  render() {
    let { entry } = this.props;

    if (!entry) return null;

    let ratio = 0;

    switch (entry.style) {
      case 'halfWidth':
        ratio = 800 / 800;
        break;
      case 'fullWidth':
        ratio = 1600 / 900;
        break;
      case 'doubleArrowRight':
        ratio = 800 / 800;
        break;
      case 'doubleArrowLeft':
        ratio = 800 / 800;
        break;
      default:
        ratio = 1600 / 900;
    }

    let images = null;

    if (entry.vimeoLink) {
      // posters

      let poster = null;
      let mobilePoster = null;

      if (entry.media && entry.media.length) {
        poster = entry.media[0].url;
      }
      if (entry.mobileMedia && entry.mobileMedia.length) {
        mobilePoster = entry.mobileMedia[0].url;
      }

      let desktop = (
        <Media
          src={entry.vimeoLink}
          poster={poster}
          hasAudio={entry.hasAudio}
          kind={'video'}
          fluid={false}
          ratio={ratio}
          autoplay={true}
          playOnVisible={false}
          controls={false}
        />
      );
      let mobile = null;
      if (entry.vimeoMobile) {
        desktop = <Breakpoints.Default key="0">{desktop}</Breakpoints.Default>;
        mobile = (
          <Breakpoints.Mobile key="1">
            <Media
              view="mobile"
              poster={mobilePoster}
              src={entry.vimeoMobile}
              hasAudio={entry.hasAudio}
              kind={'video'}
              fluid={false}
              ratio={800 / 800}
              autoplay={true}
              playOnVisible={false}
              controls={false}
            />
          </Breakpoints.Mobile>
        );
      }
      //console.log('Vimeo',mobile)
      images = [desktop, mobile];
    } else {
      let desktop = entry.media.map((img, ix) => {
        if (entry.style === 'fullWidth' && img.width && img.height) {
          ratio = img.width / img.height;
        }
        return (
          <div className={'Feature-media Feature-media--' + (ix + 1)} key={ix}>
            <Media
              key={ix}
              src={img.url}
              kind={img.kind}
              ratio={ratio}
              autoplay={true}
              playOnVisible={false}
              controls={false}
            />
          </div>
        );
      });

      let mobile = null;
      if (entry.mobileMedia && entry.mobileMedia.length) {
        desktop = <Breakpoints.Default key="0">{desktop}</Breakpoints.Default>;
        mobile = (
          <Breakpoints.Mobile key="1">
            {entry.mobileMedia.map((img, ix) => {
              return (
                <div
                  className={'Feature-media Feature-media--' + (ix + 1)}
                  key={ix}
                >
                  <Media
                    view="mobile"
                    key={ix}
                    src={img.url}
                    kind={img.kind}
                    ratio={800 / 800}
                    autoplay={true}
                    playOnVisible={false}
                    controls={false}
                  />
                </div>
              );
            })}
          </Breakpoints.Mobile>
        );
      }

      images = [desktop, mobile];
    }

    let title = entry.hideTitle ? '' : entry.projectTitle;
    if (entry.displayTitle) title = this.nl2br(entry.displayTitle);

    return (
      <div className="Feature">
        <div className="Feature-title">
          <Visible>
            <Content html={title} />
          </Visible>
        </div>

        {images}
      </div>
    );
  }
}

export default Feature;



// WEBPACK FOOTER //
// ./src/js/components/Feature/Feature.js